import React from 'react'
import PropTypes from 'prop-types';

export default function SectionWrapper(props) {
    return (
        <div className={props.className}>

            <div className='p-4'>
                <div >
                    <div className="flex flex-wrap justify-between items-center mb-2">
                        <div className='text-lg font-medium text-gray-800  capitalize '>{props.title}</div>
                        <div className='flex space-x-2 mt-2 md:mt-0 lg:mt-0 xl:m-0 '>{props.actions}
                        </div>
                    </div>
                    <div>
                        <p className='text-sm'>{props.description}</p>
                    </div>
                    
                    <div className='pt-2'>
                        {props.children}
                    </div>
                </div>

            </div>

        </div>

    )
}

SectionWrapper.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  actions: PropTypes.node,
  children: PropTypes.node,
};
